import { h } from 'preact';
import { useState, useEffect, useMemo } from 'preact/hooks';
import Accordion from '../utils/accordion';
import RichText from '../utils/richtext';
import parseJSON from '../utils/parseJSON';

const IngredientsList = ({ currentProduct }) => {
  const [ingredients, setIngredients] = useState(null);

  useEffect(() => {
    const ingredientsListJson =
      parseJSON(currentProduct?.ingredientsList?.value)
    setIngredients(ingredientsListJson);
  }, [currentProduct]);

  const List = useMemo(() => (
      <Accordion
        title={window.TMW.Strings.accordions.keyIngredientsHeading}
        classes={{
          accordion:
            'gap-5 py-[17px] border-black-30 px-[20px] laptop:px-0  border-t laptop:pr-2.5 pr-2.5',
          title: 'subheading-h4 text-black',
          content:
            'overflow-hidden max-h-[0px] transition-all duration-300 px-[20px] laptop:px-0',
        }}
      >
          <div className="mb-5">
            <p className="leading-[18px]">
              {ingredients && <RichText data={ingredients} />}
            </p>
          </div>
      </Accordion>
    ), [ingredients]);

  return !ingredients ? null : List;
};

export default IngredientsList;
